import { useState, useEffect } from "react"
import { makeStyles } from "tss-react/mui"
import { ReactSVG } from "react-svg"
import getContentUrl from "utils-lib/getContentUrl"
import getLanguageRoute from "utils-lib/getLanguageRoute"
import { Configure, InstantSearch } from "react-instantsearch"
import { searchClient } from "constants-lib/algoliaSearchClient"
import { getWindow } from "utils-lib/getWindow"
import { CustomAutoCompleteMobile } from "../Algolia"
import { Button, GenericModal } from "../Base"

const ssrWindow = getWindow()

const useStyles = makeStyles()(() => ({
  back: {
    borderBottom: `3px solid #ebebeb !important`,
    "& svg": {
      transform: `rotate(180deg)`,
      "& path, polyline": {
        stroke: `#1c8200`,
      },
    },
  },
}))

const SiteSearchMobileHeader = ({
  isSearchOpen,
  isSupportSearch,
  setIsSearchOpen,
  indexList,
  resultsIndex,
  suggestionIndex,
  queryIndex,
  filterType,
  searchPlaceholder,
  numResults,
  numHighlightedResults,
  numberQueries,
  numCharacters,
  errorMessageTitle,
  errorMessageDescription,
  failureTitle,
  failureDescription,
  suggestedText,
  resultsText,
  seeAllResultsText,
  searchDelay,
  language,
}) => {
  const [search, setSearch] = useState(``)

  const { classes } = useStyles()

  useEffect(() => {
    setIsSearchOpen(false)
  }, [])

  const languageRoute = getLanguageRoute(language)

  return (
    <GenericModal open={isSearchOpen} showCloseButton={false} useFlexibleWidth>
      <div
        style={{
          height: `100vh`,
          width: `100vw`,
          maxWidth: `100vw`,
          padding: 0,
          overflow: `auto`,
        }}
      >
        <div data-testid="SiteSearchMobileHeader">
          <Button
            fontClass="maax-font-weight-regular d-flex align-items-center"
            overrideClass={`px-3 py-2 pl-4 w-100 ${classes.back}`}
            onClick={() => {
              setIsSearchOpen(false)
            }}
            testid="SiteSearchMobileHeaderButton"
          >
            <ReactSVG
              wrapper="span"
              className="mr-2"
              src={getContentUrl(`/content/dam/mywm/icons/arrow-right.svg`)}
              beforeInjection={(svg) => {
                svg.setAttribute("aria-hidden", "true")
              }}
            />
            <div className="wm-link">Back</div>
          </Button>
        </div>
        <form
          className="flex-grow-1"
          onSubmit={(e) => {
            e.preventDefault()

            ssrWindow.location = `${languageRoute}/search?q=${encodeURIComponent(
              search,
            )}`
          }}
        >
          <InstantSearch
            searchClient={searchClient}
            indexName={resultsIndex}
            future={{ preserveSharedStateOnUnmount: true }}
            insights
          >
            <CustomAutoCompleteMobile
              isSupportSearch={isSupportSearch}
              search={search}
              setSearch={setSearch}
              filterType={filterType}
              resultsIndex={resultsIndex}
              suggestionIndex={suggestionIndex}
              queryIndex={queryIndex}
              searchPlaceholder={searchPlaceholder}
              numResults={numResults}
              numHighlightedResults={numHighlightedResults}
              numberQueries={numberQueries}
              numCharacters={numCharacters}
              errorMessageTitle={errorMessageTitle}
              errorMessageDescription={errorMessageDescription}
              failureTitle={failureTitle}
              failureDescription={failureDescription}
              onClose={() => {
                setIsSearchOpen(false)
              }}
              suggestedText={suggestedText}
              resultsText={resultsText}
              seeAllResultsText={seeAllResultsText}
              language={language}
              indexList={indexList}
              searchDelay={searchDelay}
            />
            <Configure analyticsTags={["header"]} />
          </InstantSearch>
        </form>
      </div>
    </GenericModal>
  )
}

// Note: React 19 no-longer supports propTypes. Leaving this for reference.
// SiteSearchMobileHeader.propTypes = {
//   isSearchOpen: PropTypes.func.isRequired,
//   isSupportSearch: PropTypes.bool.isRequired,
//   setIsSearchOpen: PropTypes.func.isRequired,
//   indexList: PropTypes.array.isRequired,
//   suggestionIndex: PropTypes.string.isRequired,
//   queryIndex: PropTypes.string.isRequired,
//   filterType: PropTypes.string.isRequired,
//   searchPlaceholder: PropTypes.string.isRequired,
//   numResults: PropTypes.number.isRequired,
//   numHighlightedResults: PropTypes.number.isRequired,
//   numberQueries: PropTypes.number.isRequired,
//   numCharacters: PropTypes.number.isRequired,
//   errorMessageTitle: PropTypes.string.isRequired,
//   errorMessageDescription: PropTypes.string.isRequired,
//   failureTitle: PropTypes.string.isRequired,
//   failureDescription: PropTypes.string.isRequired,
//   suggestedText: PropTypes.string.isRequired,
//   resultsText: PropTypes.string.isRequired,
//   seeAllResultsText: PropTypes.string.isRequired,
//   searchDelay: PropTypes.number.isRequired,
//   language: PropTypes.string.isRequired,
//   resultsIndex: PropTypes.string.isRequired,
// }

export default SiteSearchMobileHeader
